module.exports = __webpack_public_path__ + "static/media/9x12no2.6bc72444.jpg";